import { ElementDetails } from "@/lib/types";
import { TogglTimerProps } from "./types";

export const details = {
  name: "TogglTimer",
  description:
    "Toggl's timer functionality, with support for listing tracked entries",
  tags: ["Productivity", "Organization", "Business"],
  category: "Toggl",
  grid: {
    "extra-small": [4, 1],
    "small": [4, 2],
    "medium": [3, 3],
    "large": [4, 4],
  },
  gridNames: {
    "extra-small": "Extra Small",
    "small": "Small",
    "medium": "Medium",
    "large": "Large",
  },
  integrationsUsed: ["toggl"],
  defaultProps: {},
} as ElementDetails<TogglTimerProps>;
